import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "@/App.css";
import SEO from "@/components/SEO";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Autores from "@/components/Autores";
import Problema from "@/components/Problema";
import Solucion from "@/components/Solucion";
import Implementacion from "@/components/Implementacion";
import Continuidad from "@/components/Continuidad";
import Libros from "@/components/Libros";
import Recursos from "@/components/Recursos";
import Contacto from "@/components/Contacto";
import Footer from "@/components/Footer";
import SuccessPage from "@/components/SuccessPage";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  return (
    <>
      <SEO />
      <Navbar />
      <main>
        <Hero />
        <Autores />
        <Problema />
        <Solucion />
        <Implementacion />
        <Continuidad />
        <Libros />
        <Recursos />
        <Contacto />
      </main>
      <Footer />
    </>
  );
};

function App() {
  // Test API connection on mount
  useEffect(() => {
    const testConnection = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('API Connection:', response.data);
      } catch (error) {
        console.error('API Connection Error:', error);
      }
    };
    testConnection();
  }, []);

  return (
    <div className="App bg-reset-black">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </div>
  );
}

export default App;